export default "__VITE_PUBLIC_ASSET__0ba6f6f5__"